import { useContent } from "../ContentContext";
import { useRef } from "react";
import DarkFooter from "../sections/DarkFooter";

const TeamPage = () => {
  const content = useContent();

  // Create refs for each team member
  const teamRefs = useRef([]);

  // Function to scroll to a specific team member's section
  const scrollToBiography = (index) => {
    if (teamRefs.current[index]) {
      teamRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="bg-dark text-light flex flex-col">
      {/* Full-Screen Section */}
      <section className="relative h-screen flex-grow h-full text-white">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/videos/teampage.png"
        >
          <source src="/videos/teampage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-dark/50 via-dark/90 to-dark"></div>

        {/* Content */}
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div className="flex flex-col items-center max-w-4xl">
            {/* Subtitle */}
            <p className="uppercase text-lg sm:text-2xl tracking-wide font-garet">
              {content.teampage.subtitle}
            </p>

            {/* Title */}
            <h1 className="text-4xl sm:text-7xl my-4 font-bodoni">
              {content.teampage.title}
            </h1>

            {/* Team Names (Clickable) */}
            <div className="mt-4">
              {content.teampage.team.map((person, index) => (
                <div key={index} className="mb-2">
                  <h2
                    className="text-lg sm:text-3xl font-garet cursor-pointer hover:text-primary"
                    onClick={() => scrollToBiography(index)}
                  >
                    {person.name}
                  </h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      {content.teampage.team.map((person, index) => {
        // Determine background, text, and border colors
        const bgColor =
          index % 3 === 0
            ? "bg-dark"
            : index % 3 === 1
            ? "bg-light"
            : "bg-secondary";
        const textColor =
          index % 3 === 0 || index % 3 === 2 ? "text-light" : "text-dark";
        const borderColor =
          index % 3 === 0 || index % 3 === 1 ? "border-primary" : "border-light";

        // Assign a ref for each section
        return (
          <section
            key={index}
            ref={(el) => (teamRefs.current[index] = el)} // Assign ref
            className={`${bgColor} ${textColor} py-12`}
          >
            <div className="p-4 max-w-4xl mx-auto grid grid-cols-1 h-auto lg:h-screen">
              <div className={`flex flex-col justify-center h-full`}>
                <div className={`relative p-8`}>
                  {/* Top-Left Border */}
                  <div
                    className={`absolute top-0 left-0 w-12 h-12 border-t-4 border-l-4 ${borderColor}`}
                  ></div>

                  {/* Bottom-Right Border */}
                  <div
                    className={`absolute bottom-0 right-0 w-12 h-12 border-b-4 border-r-4 ${borderColor}`}
                  ></div>

                  {/* Content */}
                  <h3 className="text-2xl sm:text-4xl font-bodoni font-bold mb-2">
                    {person.name}
                  </h3>
                  <p className="text-1xl sm:text-2xl font-garet">
                    {person.description}
                  </p>
                </div>
              </div>
            </div>
          </section>
        );
      })}

      {DarkFooter()}
    </div>
  );
};

export default TeamPage;
